type mS = (state: any, action: any) => any;

const monitorReducerEnhancer = (createStore: any) => (reducer: any, initialState: any, enhancer: any) => {
	const monitorReducer: mS = (state: any, action: any) => {
		const newState = reducer(state, action);
		return newState;
	};
	return createStore(monitorReducer, initialState, enhancer);
};

export default monitorReducerEnhancer;
